import { BaseConnector } from './baseConnector';

class GlobalContentTypeConnector extends BaseConnector {
  getGlobalContentTypes() {
    var url = `${this.baseApiUrl}/globalContentType`;
    return this.authFetch(url);
  }
}

export { GlobalContentTypeConnector };
